"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var React = _interopRequireWildcard(require("react"));

var Styled = _interopRequireWildcard(require("./Collapsible.style"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var Collapsible =
/** @class */
function (_super) {
  (0, _tslib.__extends)(Collapsible, _super);

  function Collapsible(props) {
    var _this = _super.call(this, props) || this;

    _this.showChildren = function () {
      return _this.props.isOpen || _this.state.inTransition;
    };

    _this.setContentRef = function (node) {
      return _this.content = node;
    };

    _this.handleTransitionEnd = function () {
      _this.setState({
        inTransition: false
      });

      if (!_this.props.isOpen) {
        return _this.props.onClose ? _this.props.onClose() : null;
      } else {
        return _this.props.onOpen ? _this.props.onOpen() : null;
      }
    };

    _this.state = {
      lastKnownHeight: 0,
      inTransition: false,
      previousIsOpen: props.isOpen
    };
    _this.updateLastKnownHeight = _this.updateLastKnownHeight.bind(_this);
    return _this;
  }

  Collapsible.prototype.componentDidMount = function () {
    this.updateLastKnownHeight();
    window.addEventListener('resize', this.updateLastKnownHeight);
  };

  Collapsible.prototype.componentWillUnmount = function () {
    window.removeEventListener('resize', this.updateLastKnownHeight);
  };

  Collapsible.prototype.componentDidUpdate = function () {
    this.updateLastKnownHeight();
  };

  Collapsible.prototype.render = function () {
    var labeledById = this.props.labeledById;
    var maxHeight = this.props.isOpen ? this.state.lastKnownHeight + "px" : '0px';
    return React.createElement(Styled.Collapse, (0, _tslib.__assign)({
      className: this.props.className,
      maxHeight: maxHeight,
      isOpen: this.props.isOpen,
      onTransitionEnd: this.handleTransitionEnd,
      "aria-labelledby": labeledById,
      tabIndex: -1
    }, this.props), React.createElement("div", {
      ref: this.setContentRef
    }, this.showChildren() && this.props.children));
  };

  Collapsible.prototype.updateLastKnownHeight = function () {
    if (this.content.scrollHeight > 0) {
      this.setState({
        lastKnownHeight: this.content.scrollHeight
      });
    }
  };

  Collapsible.getDerivedStateFromProps = function (nextProps, nextState) {
    if (nextProps.isOpen !== nextState.previousIsOpen) {
      return {
        inTransition: true,
        previousIsOpen: nextProps.isOpen
      };
    }

    return {};
  };

  return Collapsible;
}(React.PureComponent);

var _default = Collapsible;
exports.default = _default;